<div class="mat-typography" (keydown)="onKeyDown($event)">
  <h1 mat-dialog-title i18n>Range Selection</h1>
  <div mat-dialog-content>
    <div>
      <mat-form-field appearance="fill">
        <mat-label i18n>From</mat-label>
        <input
          matInput
          type="number"
          placeholder="From"
          i18n-placeholder
          [min]="data.min"
          [max]="data.to"
          [(ngModel)]="data.from"
        />
      </mat-form-field>
      -
      <mat-form-field appearance="fill">
        <mat-label i18n>To</mat-label>
        <input
          matInput
          type="number"
          placeholder="To"
          i18n-placeholder
          [min]="data.from"
          [max]="data.max"
          [(ngModel)]="data.to"
        />
      </mat-form-field>
    </div>
    <div class="slider">
      <mat-slider [min]="data.min" [max]="data.max">
        <input
          matSliderStartThumb
          [value]="data.from"
          (valueChange)="data.from = $event"
        />
        <input
          matSliderEndThumb
          [value]="data.to"
          (valueChange)="data.to = $event"
        />
      </mat-slider>
    </div>
  </div>
  <div mat-dialog-actions>
    <button mat-button [mat-dialog-close]="false" i18n>Cancel</button>
    <button mat-button [mat-dialog-close]="getParameters()" i18n>OK</button>
  </div>
</div>
